import service from '@/store/services/tracking-service';

const state = {
    startPullTime: {
        user_id: 0,
        start_date: null,
        end_date: null,
        ip_address: '',
    },
    updatePullTime: {
        id: 0,
        selector_selected_date: null,
        finished_product_date: null,
    }
};

const actions = {
    savePullTime({ commit, dispatch, state }, params) {
        state.startPullTime = {
            user_id: params.userId,
            start_date: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
            end_date: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
            ip_address: localStorage.getItem('userIP')
        };
        state.updatePullTime = {
            id: 0,
            selector_selected_date: null,
            finished_product_date: null,
            product_id: null,
        };
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        return service
            .postPullTime({
                session_id: currentSession,
                ...state.startPullTime,
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
                else {
                    state.updatePullTime.id = res.data.id;
                }
            })
            .finally(() => (
                state.startPullTime = {
                    user_id: 0,
                    start_date: null,
                    end_date: null,
                    ip_address: '',
                }));
    },
    updatePullTime({ commit, dispatch, state }, params) {
        if (state.updatePullTime.id > 0 &&
            ((!params.isFinishedDate && state.updatePullTime.selector_selected_date === null) ||
                params.isFinishedDate && state.updatePullTime.finished_product_date === null)) {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            state.updatePullTime.product_id = parseInt(params.productId);
            if (params.isFinishedDate)
                state.updatePullTime.finished_product_date = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds();
            else
                state.updatePullTime.selector_selected_date = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds();
            return service
                .postUpdatePullTime({
                    session_id: currentSession,
                    ...state.updatePullTime,
                })
                .then((res) => {
                    if (res.hasOwnProperty('data') && res.data.error) {
                        commit('SET_ERROR_BIT', true, { root: true });
                        commit(
                            'SET_ERROR_INFO',
                            '<br>' +
                            'Server responded with error = True <br> errorCode: ' +
                            res.data.errorCode, { root: true }
                        );
                    }
                    else if (state.updatePullTime.finished_product_date !== null) {
                        state.updatePullTime = {
                            id: 0,
                            selector_selected_date: null,
                            finished_product_date: null,
                        };
                    }
                });
        }
    },
    async countUpdateAccount({ commit, dispatch, state }, params) {
        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        return service
            .postUpdateAccount({
                session_id: currentSession,
                user_id: params.userId,
                created_at: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
                ip_address: localStorage.getItem('userIP')
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
            });
    },
    async registerProductExport({ commit, dispatch, state }, params) {
        // Sample reports have no product instance: their routes carry no :id param
        // (e.g. /sample/industry-market-profile/annual-sales), so every caller passes
        // productId: this.$route.params.id === undefined. The API requires product_id
        // and rejects the call with errorCode "product_id_missing", which the catch
        // below surfaces as a full-screen "An error has occurred" modal on top of the
        // report the moment a user clicks Download PDF/CSV on any sample.
        // There is nothing to record for a sample export, so skip the call entirely
        // rather than tracking a null product. Guarding here fixes every product at
        // once (Market Profile, Company Profile, IF Profile, Company Profile redesign)
        // instead of patching each header component's three download handlers.
        if (!params || !params.productId) {
            return;
        }

        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        return service
            .postProductExport({
                session_id: currentSession,
                user_id: params.userId,
                created_at: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ` + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
                ip_address: localStorage.getItem('userIP'),
                product_id: params.productId,
                export_type: params.exportType
            })
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true, { root: true });
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode, { root: true }
                    );
                }
            });
    },
};

const tracking = {
    namespaced: true,
    state,
    actions,
};

export default tracking;